import {
	Component,
	OnInit,
	AfterViewInit,
	OnDestroy,
	ViewChildren,
	QueryList
} from '@angular/core'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs'
import { NotificationService } from 'src/app/services/notification.service'
import { EvaluationService } from 'src/app/services/evaluation.service'
import { ActivatedRoute } from '@angular/router'
import { Evaluation } from 'src/app/models/Evaluation'
import { ViewValidation } from 'src/app/_helpers/ViewValidation'
import { getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { UserAdmin } from 'src/app/models/UserAdmin'

@Component({
	selector: 'app-evaluation',
	templateUrl: './evaluation.component.html'
})
export class EvaluationComponent implements OnInit, AfterViewInit, OnDestroy {
	constructor(
		public notificationService: NotificationService,
		private activateRoute: ActivatedRoute,
		private evaluationService: EvaluationService
	) {}
	@ViewChildren(DataTableDirective)
	public dtElements: QueryList<DataTableDirective>
	public dtOptions: Array<DataTables.Settings> = []
	public dtTrigger: Array<Subject<any>> = []

	// @ViewChild('form') public form: NgForm
	public modal: { isOpen: boolean } = { isOpen: false }
	public modalDelete: { isOpen: boolean } = { isOpen: false }
	public tab: string = 'AV1'
	public isAdmin: boolean = false
	public loading: boolean = false
	public subscriptionAdd: any
	public subscriptionEdit: any
	public subscriptionGet: any
	public subscriptionRemove: any
	public ViewValidation: ViewValidation = new ViewValidation()
	public evaluations: Array<Evaluation> = []
	public evalsTab1: Array<Evaluation> = []
	public evalsTab2: Array<Evaluation>
	public evalsTab3: Array<Evaluation>
	public evalsTab4: Array<Evaluation>
	public evalsTab5: Array<Evaluation>
	public evalsTab6: Array<Evaluation>
	public evalsTab7: Array<Evaluation>
	public evalsTab8: Array<Evaluation>
	public evaluationSelected: Evaluation = new Evaluation()
	public totalTab: number = 0
	public AV1: string = 'AV1'
	public AV2: string = 'AV2'
	public IMP: string = 'IMP'
	public CON: string = 'CON'
	public INV1: string = 'INV1'
	public INV2: string = 'INV2'
	public OPP1: string = 'OPP1'
	public OPP2: string = 'OPP2'
	public disableButtonINV1: Boolean
	public disableButtonINV2: Boolean
	public maxOrder: number = 0
	public companyId: string = localStorage.getItem('companyId')
	public sessionUser: UserAdmin = getLoggedUser()

	public ngOnInit(): void {
		this.isAdmin = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))

		this.notificationService.starterLoading.subscribe(
			() => (this.loading = true)
		)
		this.notificationService.stopperLoading.subscribe(
			() => (this.loading = false)
		)
		document.querySelector('main').className = ''
		this.getEvaluationResolver()
		this.dtTrigger[this.AV1] = new Subject<any>()
		this.dtOptions[this.AV1] = this.setupDatatables()
		this.dtTrigger[this.AV2] = new Subject<any>()
		this.dtOptions[this.AV2] = this.setupDatatables()
		this.dtTrigger[this.IMP] = new Subject<any>()
		this.dtOptions[this.IMP] = this.setupDatatables()
		this.dtTrigger[this.CON] = new Subject<any>()
		this.dtOptions[this.CON] = this.setupDatatables()
		this.dtTrigger[this.INV1] = new Subject<any>()
		this.dtOptions[this.INV1] = this.setupDatatables()
		this.dtTrigger[this.INV2] = new Subject<any>()
		this.dtOptions[this.INV2] = this.setupDatatables()
		this.dtTrigger[this.OPP1] = new Subject<any>()
		this.dtOptions[this.OPP1] = this.setupDatatables()
		this.dtTrigger[this.OPP2] = new Subject<any>()
		this.dtOptions[this.OPP2] = this.setupDatatables()
		this.updateTotalFromTab()
	}

	public ngAfterViewInit(): void {
		this.dtTrigger[this.AV1].next()
		this.dtTrigger[this.AV2].next()
		this.dtTrigger[this.IMP].next()
		this.dtTrigger[this.CON].next()
		this.dtTrigger[this.INV1].next()
		this.dtTrigger[this.INV2].next()
		this.dtTrigger[this.OPP1].next()
		this.dtTrigger[this.OPP2].next()
	}

	public async getEvaluationResolver(): Promise<void> {
		this.evaluations = this.activateRoute.snapshot.data.evaluations
		if (!this.evaluations) {
			this.notificationService.notify('Erro ao obter Avaliações', 400)
		}
		this.evalsTab1 = this.evaluations.filter(evalu => evalu.type === 'AV1')
		this.evalsTab2 = this.evaluations.filter(evalu => evalu.type === 'AV2')
		this.evalsTab3 = this.evaluations.filter(evalu => evalu.type === 'IMP')
		this.evalsTab4 = this.evaluations.filter(evalu => evalu.type === 'CON')
		this.evalsTab5 = this.evaluations.filter(evalu => evalu.type === 'INV1')
		this.evalsTab6 = this.evaluations.filter(evalu => evalu.type === 'INV2')
		this.evalsTab7 = this.evaluations.filter(evalu => evalu.type === 'OPP1')
		this.evalsTab8 = this.evaluations.filter(evalu => evalu.type === 'OPP2')
	}

	public setTab(tab: string): void {
		this.tab = tab

		this.evalsTab5.length === 1 ? this.disableButtonINV1 = true : this.disableButtonINV1 = false
		this.evalsTab6.length === 1 ? this.disableButtonINV2 = true : this.disableButtonINV2 = false


		this.updateTotalFromTab()
	}

	public async openModal(evaluationSelected?: Evaluation): Promise<void> {
		try {
			this.modal.isOpen = true

			if (evaluationSelected) {
				this.evaluationSelected = JSON.parse(
					JSON.stringify(evaluationSelected)
				)
				this.evaluationSelected.alternatives.sort(function(a, b) {
					return a.order - b.order
				})
				this.maxOrder = this.evaluationSelected.order
			} else {
				if (this.tab === 'AV1') {
					this.maxOrder = this.evalsTab1.length + 1
				} else if (this.tab === 'AV2') {
					this.maxOrder = this.evalsTab2.length + 1
				} else if (this.tab === 'IMP') {
					this.maxOrder = this.evalsTab3.length + 1
				} else if (this.tab === 'CON') {
					this.maxOrder = this.evalsTab4.length + 1
				} else if (this.tab === 'INV1') {
					this.maxOrder = this.evalsTab5.length + 1
				} else if (this.tab === 'INV2') {
					this.maxOrder = this.evalsTab6.length + 1
				} else if (this.tab === 'OPP1') {
					this.maxOrder = this.evalsTab7.length + 1
				} else if (this.tab === 'OPP2') {
					this.maxOrder = this.evalsTab8.length + 1
				}
				this.evaluationSelected = new Evaluation()
				this.evaluationSelected.type = this.tab
				this.addAlternative()
			}
		} catch (err) {
			console.log(err)
		}
	}

	public async closeModal(): Promise<void> {
		try {
			this.modal.isOpen = false
		} catch (err) {
			console.log(err)
		}
	}

	public valueChange(value, i) {
		this.evaluationSelected.alternatives[i].value = value
	}

	public async removeAlternative(alternative: any): Promise<void> {
		try {
			if (this.evaluationSelected.alternatives.length === 1) {
				this.evaluationSelected.alternatives = []
				this.addAlternative()
			} else {
				this.evaluationSelected.alternatives = this.evaluationSelected.alternatives.filter(
					altArray => altArray.order !== alternative.order
				)
				for (
					let index: number = 0;
					index < this.evaluationSelected.alternatives.length;
					index++
				) {
					this.evaluationSelected.alternatives[index].order =
						index + 1
				}
			}
		} catch (err) {
			console.log(err)
		}
	}

	public getValueFromAlternatives(evaluation: any): number {
		// Escala {true}

		if (evaluation.scale && evaluation.scale.checked) {
			return Number(evaluation.scale.value)
		}

		const valueTotal = evaluation.alternatives.map(obj => obj.value)

		// Multipla escolha {true} e Escala {false}
		if (evaluation.multiple_answer) {
			return Number(
				valueTotal.reduce(
					(accumulator, currentValue) => accumulator + currentValue,
					0
				)
			)
		}
		return Array.isArray(valueTotal) ? 0 : Math.max(...valueTotal)
	}

	public updateTotalFromTab(): void {
		this.totalTab = 0
		for (let j = 0; j < this.evaluations.length; j++) {
			if (this.evaluations[j].type === this.tab) {
				this.totalTab += this.getValueFromAlternatives(
					this.evaluations[j]
				)
			}
		}
	}

	public async addAlternative(): Promise<void> {
		try {
			this.evaluationSelected.alternatives.push({
				text: '',
				order: this.evaluationSelected.alternatives.length + 1,
				value: null,
				color: '#008000',
				...(this.tab === 'OPP2' || this.tab === 'INV2' ? { isDefaultForUnscheduledOperation: false } : null)
			})
		} catch (err) {
			console.log(err)
		}
	}

	public async removeQuestion(): Promise<void> {
		try {
			this.subscriptionRemove = this.evaluationService
				.inactiveEvaluation(this.evaluationSelected._id)
				.subscribe(
					data => {
						this.refresh()
						this.notificationService.notify(data.message, 200)
					},
					error => {
						console.log(error)
					}
				)
		} catch (err) {
			console.log(err)
		}
	}

	public async createOrEditQuestion(): Promise<void> {
		try {
			this.evaluationSelected.order = this.maxOrder
			this.evaluationSelected.user = this.sessionUser._id
			this.evaluationSelected.companyId = this.companyId

			this.subscriptionAdd = this.evaluationService
				.saveEvaluation(this.evaluationSelected)
				.subscribe(
					data => {
						this.refresh()
						this.notificationService.notify(data.message, 200)
					},
					error => {
						console.log(error)
					}
				)
		} catch (err) {
			console.log(err)
		}
	}

	public handleMandatoryPhoto(): void {
		// Logica invertida pois o onclick é chamado antes da mudança de valor da flag
		if (this.evaluationSelected.mandatory_question) {
			this.evaluationSelected.mandatory_photo = false
		}
	}

	public handleScale(): void {
		this.evaluationSelected.scale.value = undefined
		this.evaluationSelected.alternatives.forEach(
			alt => (alt.value = undefined)
		)
	}

	public handleOther(): void {
		// Logica invertida pois o onclick é chamado antes da mudança de valor da flag
		if (this.evaluationSelected.other.checked) {
			this.evaluationSelected.other.text = undefined
		}
	}

	public handleMultipleAnswer(): void {
		if (!this.evaluationSelected.multiple_answer) {
			// Se estiver ativando, não fazer nada
			return
		}

		this.evaluationSelected.alternatives.forEach(alternative => {
			alternative.isDefaultForUnscheduledOperation = false
		})
	}

	public handleAnswerUnscheduledOperation(indexAlternative: number): void {
		if (!this.evaluationSelected.multiple_answer) {
			this.evaluationSelected.alternatives.forEach((alternative, index) => {
				if (index === indexAlternative) {
					alternative.isDefaultForUnscheduledOperation = !alternative.isDefaultForUnscheduledOperation
				} else {
					alternative.isDefaultForUnscheduledOperation = false
				}
			})
		}
	}


	public getModalTitle(): string {
		if (this.evaluationSelected._id) {
			return `Editar Avaliação (${this.tab})`
		}

		return `Nova Avaliação (${this.tab})`
	}

	public async refresh(): Promise<void> {
		this.modal.isOpen = false
		this.modalDelete.isOpen = false
		document.querySelector('main').className = ''
		this.evaluationSelected = new Evaluation()
		this.evaluations = await this.evaluationService
			.getEvaluations(this.companyId)
			.toPromise()
		if (this.tab === 'AV1') {
			this.evalsTab1 = this.evaluations.filter(
				evalu => evalu.type === 'AV1'
			)
		} else if (this.tab === 'AV2') {
			this.evalsTab2 = this.evaluations.filter(
				evalu => evalu.type === 'AV2'
			)
		} else if (this.tab === 'IMP') {
			this.evalsTab3 = this.evaluations.filter(
				evalu => evalu.type === 'IMP'
			)
		} else if (this.tab === 'CON') {
			this.evalsTab4 = this.evaluations.filter(
				evalu => evalu.type === 'CON'
			)
		} else if (this.tab === 'INV1') {
			this.evalsTab5 = this.evaluations.filter(
				evalu => evalu.type === 'INV1'
			)
		} else if (this.tab === 'INV2') {
			this.evalsTab6 = this.evaluations.filter(
				evalu => evalu.type === 'INV2'
			)
		} else if (this.tab === 'OPP1') {
			this.evalsTab7 = this.evaluations.filter(
				evalu => evalu.type === 'OPP1'
			)
		} else if (this.tab === 'OPP2') {
			this.evalsTab8 = this.evaluations.filter(
				evalu => evalu.type === 'OPP2'
			)
		}
		this.evalsTab5.length === 1 ? this.disableButtonINV1 = true : this.disableButtonINV1 = false
		this.evalsTab6.length === 1 ? this.disableButtonINV2 = true : this.disableButtonINV2 = false

		this.reRender()
		this.updateTotalFromTab()
	}

	public openModalDelete(evaluationSelected: any): void {
		this.modalDelete.isOpen = true
		this.evaluationSelected = evaluationSelected
	}

	public closeModalDelete(): void {
		this.modalDelete.isOpen = false
	}

	private setupDatatables(): any {
		return {
			language: {
				url:
					'//cdn.datatables.net/plug-ins/1.10.19/i18n/Portuguese-Brasil.json'
			},
			pagingType: 'full_numbers',
			paging: true,
			searching: true,
			ordering: true,
			info: true,
			autoWidth: false,
			pageLength: 10,
			lengthChange: false,
			columnDefs: [
				{
					targets: 'no-sort',
					orderable: false,
					width: '.1%'
				},
				{
					type: 'num',
					targets: 0
				}
			],
			order: [[0, 'asc']]
		}
	}

	private reRender(): void {
		this.dtElements.forEach(
			(dtElement: DataTableDirective, contador: number) => {
				if (dtElement.dtInstance) {
					dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
						// document.querySelector('table').classList.add('hide')
						this.updateDatatable(contador, dtInstance)
						setTimeout(() => {
							// document.querySelector('table').classList.remove('hide')
						}, 700)
					})
				} else {
					this.updateDatatable(contador)
				}
			}
		)
	}

	private updateDatatable(
		contador: number,
		dtInstance?: DataTables.Api
	): void {
		if (contador === 0 && this.tab === 'AV1') {
			if (dtInstance) dtInstance.destroy()
			this.dtTrigger[this.AV1].next()
		} else if (contador === 1 && this.tab === 'AV2') {
			if (dtInstance) dtInstance.destroy()
			this.dtTrigger[this.AV2].next()
		} else if (contador === 2 && this.tab === 'IMP') {
			if (dtInstance) dtInstance.destroy()
			this.dtTrigger[this.IMP].next()
		} else if (contador === 3 && this.tab === 'CON') {
			if (dtInstance) dtInstance.destroy()
			this.dtTrigger[this.CON].next()
		} else if (contador === 4 && this.tab === 'INV1') {
			if (dtInstance) dtInstance.destroy()
			this.dtTrigger[this.INV1].next()
		} else if (contador === 5 && this.tab === 'INV2') {
			if (dtInstance) dtInstance.destroy()
			this.dtTrigger[this.INV2].next()
		} else if (contador === 6 && this.tab === 'OPP1') {
			if (dtInstance) dtInstance.destroy()
			this.dtTrigger[this.OPP1].next()
		} else if (contador === 7 && this.tab === 'OPP2') {
			if (dtInstance) dtInstance.destroy()
			this.dtTrigger[this.OPP2].next()
		}


	}

	public ngOnDestroy(): void {
		// if (this.subscriptionAdd) this.subscriptionAdd.unsubscribe()
		// if (this.subscriptionGet) this.subscriptionGet.unsubscribe()
		// if (this.subscriptionRemove) this.subscriptionRemove.unsubscribe()
	}

	public maxOrderValidation(
		maxOrder: number,
		evaluationSelected: any
	): boolean {
		if (maxOrder && maxOrder > 0) {
			if (evaluationSelected._id) {
				if (this.tab === 'AV1') {
					return maxOrder <= this.evalsTab1.length
				} else if (this.tab === 'AV2') {
					return maxOrder <= this.evalsTab2.length
				} else if (this.tab === 'IMP') {
					return maxOrder <= this.evalsTab3.length
				} else if (this.tab === 'CON') {
					return maxOrder <= this.evalsTab4.length
				} else if (this.tab === 'INV1') {
					return maxOrder <= this.evalsTab5.length
				} else if (this.tab === 'INV2') {
					return maxOrder <= this.evalsTab6.length
				} else if (this.tab === 'OPP1') {
					return maxOrder <= this.evalsTab7.length
				} else if (this.tab === 'OPP2') {
					return maxOrder <= this.evalsTab8.length
				}

			} else {
				if (this.tab === 'AV1') {
					return maxOrder <= this.evalsTab1.length + 1
				} else if (this.tab === 'AV2') {
					return maxOrder <= this.evalsTab2.length + 1
				} else if (this.tab === 'IMP') {
					return maxOrder <= this.evalsTab3.length + 1
				} else if (this.tab === 'CON') {
					return maxOrder <= this.evalsTab4.length + 1
				} else if (this.tab === 'INV1') {
					return maxOrder <= this.evalsTab5.length + 1
				} else if (this.tab === 'INV2') {
					return maxOrder <= this.evalsTab6.length + 1
				} else if (this.tab === 'OPP1') {
					return maxOrder <= this.evalsTab7.length + 1
				} else if (this.tab === 'OPP2') {
					return maxOrder <= this.evalsTab8.length + 1
				}
			}
		}

		return false
	}
}
